module.exports = __webpack_public_path__ + "static/media/23.aed5bfac.svg";